<template>
  <div class="absolute inset-0 h-full w-full z-50">
    <div class="box">
      <span
        class="text-error-10 text-sm md:text-base font-bold flex items-center gap-3"
        test-id="title"
      >
        <dispute-icon />
        KYC Disputed
      </span>

      <div class="text-error-10 text-sm md:text-base">
        <p>Some sections of your KYC have been disputed.</p>
        <p class="mt-1">
          Kindly complete those sections with the correct information and
          <strong>re-submit</strong> the KYC
        </p>
      </div>

      <button
        class="text-xs md:text:sm self-end bg-error-20 text-white rounded-lg px-6 py-2 hover:opacity-70 border-0 outline-none"
        test-id="button"
        @click="handleClose"
      >
        Close
      </button>
    </div>
  </div>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'

export default {
  name: 'DisputeModal',
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  components: {
    DisputeIcon: () => import('@/assets/v2/icons/AlertCircle.vue')
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '33%' : breakpoints.mdAndUp ? '70%' : '90%'
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeModal')
    }
  },
  mounted () {
    setTimeout(() => this.handleClose(), 8000)
  }
}
</script>

<style lang="scss" scoped>
.box {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 90%;
  padding: 15px 20px;
  margin-top: 30px;
  border-radius: 12px;
  background-color: #fcf1f3;
  transform: translateX(3%);

  @media screen and (min-width: 768px) {
    width: 55%;
  }
  @media screen and (min-width: 1200px) {
    transform: translateX(8%);
    width: 30%;
  }
}
</style>
